import React, {Fragment, useRef, useState} from "react";
import {Button, Col, Modal, Row} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import RestClient from "../../RestAPI/RestClient";
import AppUrl from "../../RestAPI/AppUrl";
import cogoToast from "cogo-toast";
import Loading from "../Loading/Loading";
import LoadingText from "../Loading/LoadingText";
import {useSelector} from "react-redux";
import appUtility from "../../RestAPI/AppUtility";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import ReactToPrint from "react-to-print";


export default function PendingVisit(){
    let state=useSelector((state)=> state);
    const ref=useRef();

    const [DivisionVisit, setDivisionVist]=useState([]);
    const [CircleVisit, setCircleVisit]=useState([]);
    const [DataVisit, setDataVisit]=useState([]);
    const [ColumnVisit, setColumnVisit]=useState([{}]);

    const [DataLengthVisit, setDatalengthVisit]=useState(0);
    const [IdVisit, setIdVisit]=useState();
    const [BinVisit, setBinVisit]=useState();

    const[DataStatusVisit, setDataStatusVisit]=useState(false);




    const [ShowMapVisitStatus, setShowMapVisitStatus] = useState(false);
    const handleCloseMapVisitStatus = () => setShowMapVisitStatus(false);
    const handleShowMapVisitStatus = () => setShowMapVisitStatus(true);

    const [ShowMapVisit, setShowMapVisit] = useState(false);
    const handleCloseMapVisit = () => setShowMapVisit(false);
    const handleShowMapVisit = () => setShowMapVisit(true);
    const selectRow={
        mode:'radio',
        onSelect:(row,isSelect,rowIndex)=>{
            setIdVisit(row['Id']);
            handleShowMapVisitStatus();
        }
    }

    const getVisitMap=()=>{
        setDataStatusVisit(true);
        setDatalengthVisit(0)

        const Commi=document.getElementById("cmbCommiVisit");
        const CommiValue=Commi.options[Commi.selectedIndex].text;

        const DivisionVisit=document.getElementById("cmbDivisionVisit");
        const DivisionValueVisit=DivisionVisit.options[DivisionVisit.selectedIndex].text;

        const CircleVisit=document.getElementById("cmbCircleVisit");
        const CircleValueVisit=CircleVisit.options[CircleVisit.selectedIndex].text;

        const OfficerVisit=document.getElementById("txtOfficerVisit").value;

        const VisitStatus=document.getElementById("cmbStatusVisit");
        const VisitStatusValue=VisitStatus.options[VisitStatus.selectedIndex].text;



        const DataLimitVisit=document.getElementById("cmbDataLimitVisit");
        const DataLimitValueVisit=DataLimitVisit.options[DataLimitVisit.selectedIndex].text;

        let getCommiVisit=" ";
        let getDivisionVisit=" ";
        let getCircleVisit=" ";

        let getStatusVisit="" ;
        let getOfficerVisit="" ;


        let getlimitVisit ="";

        let jsonObject;



        if(state.accessCom=="NBR")
        {if(Commi.selectedIndex!=0){getCommiVisit="And Commissionerate Like '%"+CommiValue+"%'"}}
        else{getCommiVisit="And Commissionerate Like '%"+state.accessCom+"%'"}

        if(state.accessDiv=="All Division"){if(DivisionVisit.selectedIndex!=0){getDivisionVisit="And Division Like '%"+DivisionValueVisit+"%'"}}
        else{getDivisionVisit="And Division Like '%"+state.accessDiv+"%'"}

        if(state.accessCir=="All Circle"){if(CircleVisit.selectedIndex!=0){getCircleVisit="And Circle = '"+CircleValueVisit+"'"}}
        else {getCircleVisit="And Circle = '"+state.accessCir+"'"}


        if(OfficerVisit!=""){getOfficerVisit="And Officer Like '%"+OfficerVisit+"%'"}
        if(VisitStatus.selectedIndex !=2){getStatusVisit=" And Status ='"+VisitStatusValue+"' " }





        if(DataLimitVisit.selectedIndex !=0){getlimitVisit=" LIMIT " +DataLimitValueVisit

            jsonObject={"sql":"select Id,Division,Circle,Entry_Date,DATEDIFF(CURDATE(),Entry_Date ) AS Total_Days,Status,Finish_Date,Location,Officer,Comments from pending_visit " +
                    "where 1=1 "+getDivisionVisit+" "+getCircleVisit+" "+getOfficerVisit+" "+getStatusVisit+" "+getlimitVisit+" "}



        }else{getlimitVisit=""

            jsonObject={"sql":" Select count(Id)AS 'Total ID' from Pending_Visit where 1=1 "+getDivisionVisit+" "+getCircleVisit+" "+getOfficerVisit+" "+getStatusVisit+" "+getlimitVisit+"  "}



        }

        setColumnVisit([{}]);setDataVisit([])
        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{
            setDatalengthVisit(result.length)
            if(result==""){cogoToast.error("Data not found");setDataStatusVisit(false)}else {
                await setColumnVisit(
                    Object.keys(result[0]).map((k) => {
                        return {dataField: k, text: k, sort: true}
                    })
                )
                await setDataVisit(result);
                setDataStatusVisit(false)
            }
        }).catch(error=>{ setDataStatusVisit(false);});
    }


    const saveVisiteMap=()=>{

            const latLangVisit=document.getElementById("txtLatLangVisit").value;

        const DivisionVisit=document.getElementById("cmbDivisionVisit");
        const DivisionValueVisit=DivisionVisit.options[DivisionVisit.selectedIndex].text;

        const CircleVisit=document.getElementById("cmbCircleVisit");
        const CircleValueVisit=CircleVisit.options[CircleVisit.selectedIndex].text;

       let jsonObject={"sql":"Insert into Pending_Visit (Id,Division,Circle,Entry_Date,Location,Officer)" +
               "Values(NULL,'"+DivisionValueVisit+"','"+CircleValueVisit+"','"+appUtility.getDate(new Date())+"','"+latLangVisit+"','"+state.name+"')"};

       if(DivisionVisit.selectedIndex==0){cogoToast.error("Please select Division");}else{
       if(CircleVisit.selectedIndex==0){cogoToast.error("Please select Circle");}else{
       if(latLangVisit==""){cogoToast.error("Please Insert Map Coordinate");}else{


            RestClient.PostRequest(AppUrl.saveData,jsonObject ).then(result => {
                if (result == 1) {
                    cogoToast.success("Map Data saved")

                } else {
                    cogoToast.error("Map Data not saved")
                }
            }).catch(error => {
                cogoToast.error(error)
            });
       }}}


    }
    const updateVisitStatus=()=>{

        const VisitDoneComments=document.getElementById("txtVisitDomeComments").value;



           let jsonObject={"sql": "Update Pending_Visit set Status='Done',Comments='"+VisitDoneComments+"',Finish_Date='"+appUtility.getDate(new Date())+"',Officer='"+state.name+"' where Id='"+IdVisit+"' "};


        if(VisitDoneComments==""){cogoToast.error("Please insert Comments")}else {
            RestClient.PostRequest(AppUrl.updateData,jsonObject ).then(result => {
                if (result == 1) {
                    cogoToast.success("Task done saved")

                } else {
                    cogoToast.error("Task done not saved")
                }
            }).catch(error => {
                cogoToast.error(error)
            });
        }

    }
    return(
        <Fragment>
            <div >
                <Row className="mt-2">

                    <Col lg={3}>
                        <div className="">
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">NBR</label></Col>
                                <Col lg={9}  xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbCommiVisit"
                                            onChange={()=>{
                                                setDivisionVist([]);
                                                setCircleVisit([]);
                                                const e = document.getElementById("cmbCommiVisit");
                                                const value = e.options[e.selectedIndex].value;
                                                const dt=state.division.filter(x => x.Commissionerate_Id==value);
                                                setDivisionVist(dt)


                                            }}
                                    >
                                        <option >NBR</option>
                                        {
                                            state.commi.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }
                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Division</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbDivisionVisit"
                                            onChange={()=>{
                                                setCircleVisit([])
                                                const e = document.getElementById("cmbDivisionVisit");
                                                const value = e.options[e.selectedIndex].value;
                                                const dt=state.circle.filter(x => x.Division_Id==value);
                                                setCircleVisit(dt)


                                            }}
                                    >
                                        <option >All Division</option>

                                        {
                                            DivisionVisit.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }
                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Circle</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbCircleVisit" >
                                        <option >All Circle</option>

                                        {
                                            CircleVisit.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }


                                    </select>
                                </Col>
                            </Row>

                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Status</label></Col>
                                <Col lg={9}xs={8}>
                                    <select defaultValue={100} className="float-start w-100 customfontsize" id="cmbStatusVisit"  >
                                        <option >Pending</option>
                                        <option >Done</option>
                                        <option >All</option>
                                    </select>
                                </Col>

                            </Row>

                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Officer</label></Col>
                                <Col lg={9}xs={8}>
                                    <input type="text" className="w-100" id="txtOfficerVisit"/>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Data</label></Col>
                                <Col lg={9}xs={8}>
                                    <select defaultValue={100} className="float-start w-100 customfontsize" id="cmbDataLimitVisit"  >
                                        <option >All</option>
                                        <option >100</option>
                                        <option >200</option>
                                        <option >500</option>
                                        <option >1000</option>
                                        <option >2000</option>
                                        <option >3000</option>
                                        <option >5000</option>
                                        <option >10000</option>
                                        <option >20000</option>
                                        <option >50000</option>


                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-4">
                                <Col lg={3} >

                                </Col>
                                <Col lg={9} >
                                    <button className="w-100 text-danger" onClick={getVisitMap}>Search</button>
                                </Col>


                            </Row>
                            <Row className="mt-4">
                                <Col lg={3} >

                                </Col>
                                <Col lg={9} >
                                    <button className="w-100 text-danger" onClick={handleShowMapVisit}>Entry Map Visit</button>
                                </Col>


                            </Row>



                        </div>
                    </Col>

                    <Col lg={9}>

                        <div className="overflow-scroll animated zoomIn purchaseMedium2Div">
                            {
                                DataStatusVisit? <LoadingText/>
                                    :<BootstrapTable ref={ref} selectRow={selectRow} id="BinTable" keyField='Id' data={DataVisit} columns={ColumnVisit}></BootstrapTable>


                            }
                        </div>
                        <di>
                            <label className="text-danger">Data found: {DataLengthVisit}</label>

                        </di>

                    </Col>


                </Row>


            </div>

            <Modal show={ShowMapVisitStatus} onHide={handleCloseMapVisitStatus} >
                <Modal.Header closeButton>

                    <label>Done Data</label>

                </Modal.Header>
                <Modal.Body >
                    <label>Comments</label>
                    <input id="txtVisitDomeComments"/>

                </Modal.Body>
                <Modal.Footer>

                    <Button variant="primary" onClick={updateVisitStatus} >Save</Button>
                    <Button variant="danger" onClick={handleCloseMapVisitStatus}>Close</Button>

                </Modal.Footer>
            </Modal>
            <Modal show={ShowMapVisit} onHide={handleCloseMapVisit} >
                <Modal.Header closeButton>

                    <label>Entry Data</label>

                </Modal.Header>
                <Modal.Body >
                    <label>Latitude</label>
                    <input id="txtLatLangVisit"/>

                </Modal.Body>
                <Modal.Footer>

                    <Button variant="danger" onClick={saveVisiteMap}>Save</Button>

                </Modal.Footer>
            </Modal>



        </Fragment>

    )
}
